import styled from 'styled-components/macro';

export const LogoHolder = styled.div`
  max-width: 80px;
  @media (min-width: 768px) {
    max-width: 107px;
  }
`;
export const Img = styled.img``;
